import pdfMake from "pdfmake/build/pdfmake";
import vfsFonts from "pdfmake/build/vfs_fonts";
import Config from "../../../../constantes/Config";
import * as util from "../../../../utils/MascaraUtil";
import * as CsTipoUnidade from "../../../../constantes/CsTipoUnidade";
import * as CsSituacao from "../../../../constantes/CsSituacaoOrcamento";
import { sessaoStore } from "../../../../stores";

const defaultStyles = {
  header: {
    fontSize: 12,
    bold: true,
    margin: [0, 10, 0, 10]
  },
  subheader: {
    fontSize: 10,
    margin: [0, 5, 0, 5]
  },
  h4: {
    fontSize: 14,
    bold: true,
    margin: [0, 5, 0, 5]
  },
  h5: {
    fontSize: 12,
    bold: true,
    margin: [0, 5, 0, 5]
  },
  h6: {
    fontSize: 10,
    bold: true,
    margin: [0, 5, 0, 5]
  },
  label: {
    bold: true,
    margin: [0, 10, 0, 5]
  },
  text_muted: {
    color: "#73818f"
  },
  text_primary: {
    color: "#20a8d8"
  },
  table: {
    fontSize: 8
  },
  table_header: {
    bold: true,
    fontSize: 9,
    fillColor: "#f0f3f5",
    margin: [0, 5, 0, 5]
  }
};

const defaultHeader = (empresa, nome, usuario) => ({
  columnGap: 10,
  columns: [
    {
      width: 50,
      stack: [{ image: empresa.url_brasao || "...", width: 50, height: 50 }]
    },
    {
      width: "*",
      stack: [
        { text: empresa.nome },
        {
          text: empresa.cidade,
          fontSize: 8,
          margin: [0, 0, 0, 10],
          style: "text_muted"
        },
        { text: nome, bold: true, fontSize: 12 }
      ]
    },
    {
      width: 100,
      stack: [
        {
          text: Config.DESCRICAO_APP,
          alignment: "right",
          fontSize: 8,
          style: "text_muted"
        }
      ]
    }
  ]
});

const defaultFooter = (currentPage, pageCount) => {
  const event = new Date();

  return {
    fontSize: 8,
    margin: [15, 5, 15, 5],
    borders: [0, 1, 0, 0],
    columns: [
      { text: Config.NOME_APP },
      {
        text: event.toLocaleString("pt-BR", { timeZone: "America/Recife" }),
        alignment: "center"
      },
      {
        text: `Página ${currentPage.toString()} de ${pageCount}`,
        alignment: "right"
      }
    ]
  };
};

const detalheOrcamento = (empresa, orcamento, usuario) => [
  defaultHeader(empresa, `Detalhamento do Orçamento`, usuario),
  {
    canvas: [
      {
        type: "line",
        x1: 0,
        y1: 1,
        x2: 565,
        y2: 1,
        lineWidth: 0.1,
        lineColor: "#c8ced3"
      }
    ],
    margin: [0, 10, 0, 10]
  },
  { text: `ORÇAMENTO #${orcamento.id}`, style: ["header", "text_primary"] },
  {
    fontSize: 10,
    margin: [0, 0, 0, 50],
    stack: [
      { text: "Nome", style: "label" },
      orcamento.nome,
      { text: "Descrição", style: "label" },
      orcamento.descricao,
      { text: "Obra", style: "label" },
      orcamento.titulo,
      { text: "Órgão", style: "label" },
      { text: orcamento.orgao }
    ]
  },
  {
    canvas: [
      {
        type: "line",
        x1: 0,
        y1: 1,
        x2: 565,
        y2: 1,
        lineWidth: 0.1,
        lineColor: "#c8ced3"
      }
    ],
    margin: [0, 10, 0, 10]
  },
  {
    columnGap: 10,
    fontSize: 10,
    alignment: "center",
    columns: [
      {
        stack: [{ text: "LEIS SOCIAIS", style: "label" }, { text: util.percentual(orcamento.percentualLeisSociais), style: "text_primary" }]
      },
      {
        stack: [{ text: "BDI", style: "label" }, { text: util.percentual(orcamento.percentualTotalBDI), style: "text_primary" }]
      },
      {
        stack: [{ text: "VALOR TOTAL (R$)", style: "label" }, { text: util.moeda(orcamento.valorTotalGeral), style: "text_primary" }]
      },
      {
        stack: [{ text: "SITUAÇÃO", style: "label" }, { text: CsSituacao.valueOf(orcamento.situacao).descricao, style: "text_primary" }]
      },
      {
        stack: [{ text: "DATA INCLUSÃO", style: "label" }, { text: orcamento.dataInclusao, style: "text_primary" }]
      }
    ],
    pageBreak: "after"
  }
];

const exportarRelatorio = (empresa, orcamento, usuario) => {
  const planilha = [];
  const composicoes = [];

  planilha.push([
    { text: "Item", style: "table_header" },
    { text: "Descrição", style: "table_header" },
    { text: "Unid.", style: "table_header" },
    { text: "Quant.", style: "table_header" },
    { text: "Valor Unit. R$", style: "table_header" },
    { text: "Valor Total R$", style: "table_header" }
  ]);

  composicoes.push([
    { text: "Serviço", style: "table_header" },
    { text: "Unid.", style: "table_header" },
    { text: "Quant.", style: "table_header" },
    { text: "Valor Unit. R$", style: "table_header" },
    { text: "Valor Total R$", style: "table_header" }
  ]);

  if (orcamento.etapas) {
    orcamento.etapas.forEach(etapa => {
      planilha.push([{ text: `${etapa.codigo} ${etapa.nome}`, colSpan: 6, style: "h6" }, {}, {}, {}, {}, {}]);

      if (etapa.itens) {
        etapa.itens.forEach(item => {
          planilha.push([{ text: item.codigo, style: "h6" }, { text: item.nome, colSpan: 5, style: "h6" }, {}, {}, {}, {}]);

          if (item.servicos) {
            item.servicos.forEach((servico, x) => {
              planilha.push([
                { text: `${item.codigo}.${x + 1}` },
                { text: servico.nome },
                { text: servico.unidade },
                { text: util.quantidade(servico.quantidade) },
                { text: servico.valorTotal, alignment: "right" },
                { text: servico.valorTotalGeral, alignment: "right" }
              ]);

              composicoes.push([
                { text: servico.nome, bold: true, colSpan: 4 },
                {},
                {},
                {},
                { text: servico.unidade, alignment: "right", bold: true }
              ]);

              servico.itens.forEach(i => {
                composicoes.push([
                  { text: i.nome },
                  { text: CsTipoUnidade.valueOf(i.tipoUnidade).simbolo },
                  { text: util.quantidade(i.quantidade) },
                  { text: util.moeda(i.valor), alignment: "right" },
                  { text: util.moeda(i.valorTotal), alignment: "right" }
                ]);
              });

              composicoes.push([
                { text: "Custo do material", colSpan: 3, alignment: "right" },
                {},
                {},
                {},
                { text: util.moeda(servico.valorTotalMaterial), alignment: "right" }
              ]);
              composicoes.push([
                { text: "Mão de Obra", colSpan: 3, alignment: "right" },
                {},
                {},
                {},
                { text: util.moeda(servico.valorTotalMaoObra), alignment: "right" }
              ]);
              composicoes.push([
                { text: "Leis Sociais", colSpan: 3, alignment: "right" },
                {},
                {},
                { text: util.percentual(servico.percentualTotalLeisSociais), alignment: "right" },
                { text: util.moeda(servico.valorTotalLeisSociais), alignment: "right" }
              ]);
              composicoes.push([
                {
                  text: "SUBTOTAL (R$)",
                  colSpan: 3,
                  bold: true,
                  alignment: "right"
                },
                {},
                {},
                {},
                { text: util.moeda(servico.valorSubTotal), bold: true, alignment: "right" }
              ]);
              composicoes.push([
                { text: "BDI", colSpan: 3, alignment: "right" },
                {},
                {},
                { text: util.percentual(servico.percentualBdi), alignment: "right" },
                { text: util.moeda(servico.valorTotalTaxaBdi), alignment: "right" }
              ]);
              composicoes.push([
                {
                  text: "TOTAL (R$)",
                  colSpan: 3,
                  bold: true,
                  alignment: "right"
                },
                {},
                {},
                {},
                { text: servico.valorTotal, bold: true, alignment: "right" }
              ]);
              composicoes.push([{ text: "", colSpan: 5, margin: [0, 20, 0, 0] }, "", "", "", ""]);
            });
          }

          planilha.push([
            {
              text: "TOTAL",
              colSpan: 4,
              alignment: "right",
              bold: true
            },
            {},
            {},
            {},
            {
              text: util.moeda(item.valorTotal),
              colSpan: 2,
              alignment: "right",
              bold: true
            }
          ]);
        });
      }

      planilha.push([
        { text: "VALOR DOS SERVIÇOS NESTA ESTAPA", colSpan: 4, style: "h6" },
        {},
        {},
        {},
        {
          text: util.moeda(etapa.valorTotal),
          colSpan: 2,
          style: "h6",
          alignment: "right"
        }
      ]);
    });
  }

  planilha.push([
    { text: "TOTAL GERAL", style: "h6", colSpan: 5 },
    {},
    {},
    {},
    {},
    { text: util.moeda(orcamento.valorTotalGeral), style: "h6", alignment: "right" }
  ]);

  const doc = {
    content: [
      defaultHeader(empresa, `Detalhamento do Orçamento`, usuario),
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 1,
            x2: 565,
            y2: 1,
            lineWidth: 0.1,
            lineColor: "#c8ced3"
          }
        ],
        margin: [0, 10, 0, 10]
      },
      // { text: `ORÇAMENTO #${orcamento.id}`, style: ["header", "text_primary"] },
      {
        fontSize: 10,
        margin: [0, 0, 0, 50],
        stack: [
          { text: "Nome", style: "label" },
          orcamento.nome,
          { text: "Descrição", style: "label" },
          orcamento.descricao,
          { text: "Obra", style: "label" },
          orcamento.titulo,
          { text: "Órgão", style: "label" },
          { text: orcamento.orgao }
        ]
      },
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 1,
            x2: 565,
            y2: 1,
            lineWidth: 0.1,
            lineColor: "#c8ced3"
          }
        ],
        margin: [0, 10, 0, 10]
      },
      {
        columnGap: 10,
        fontSize: 10,
        alignment: "center",
        columns: [
          {
            stack: [{ text: "LEIS SOCIAIS", style: "label" }, { text: util.percentual(orcamento.percentualLeisSociais), style: "text_primary" }]
          },
          {
            stack: [{ text: "BDI", style: "label" }, { text: util.percentual(orcamento.percentualTotalBDI), style: "text_primary" }]
          },
          {
            stack: [{ text: "VALOR TOTAL (R$)", style: "label" }, { text: util.moeda(orcamento.valorTotalGeral), style: "text_primary" }]
          },
          {
            stack: [{ text: "SITUAÇÃO", style: "label" }, { text: CsSituacao.valueOf(orcamento.situacao).descricao, style: "text_primary" }]
          },
          {
            stack: [{ text: "DATA INCLUSÃO", style: "label" }, { text: orcamento.dataInclusao, style: "text_primary" }]
          }
        ],
        pageBreak: "after"
      },
      defaultHeader(empresa, orcamento.nome, usuario),
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 1,
            x2: 565,
            y2: 1,
            lineWidth: 0.1,
            lineColor: "#c8ced3"
          }
        ],
        margin: [0, 10, 0, 10]
      },
      { text: "PLANILHA DE PREÇOS", style: ["header", "text_primary"] },
      {
        style: "table",
        table: {
          headerRows: 1,
          widths: [30, "*", 25, 45, 60, 90],
          body: planilha.slice()
        },
        pageBreak: "after"
      },
      defaultHeader(empresa, orcamento.nome, usuario),
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 1,
            x2: 565,
            y2: 1,
            lineWidth: 0.1,
            lineColor: "#c8ced3"
          }
        ],
        margin: [0, 10, 0, 10]
      },
      { text: "COMPOSIÇÃO DE PREÇOS", style: ["header", "text_primary"] },
      {
        style: "table",
        table: {
          headerRows: 1,
          widths: ["*", 25, 45, 60, 90],
          body: composicoes.slice()
        }
      }
    ],
    footer: defaultFooter,
    defaultFileName: "orcamento.pdf",
    pageSize: "A4",
    pageOrientation: "portrait",
    pageMargins: [15, 20, 15, 30],
    styles: defaultStyles
  };

  const { vfs } = vfsFonts.pdfMake;
  pdfMake.vfs = vfs;

  pdfMake.createPdf(doc).open();
};

const exportarDetalhe = (empresa, orcamento, usuario) => {
  const planilha = [];

  planilha.push([
    { text: "Item", style: "table_header" },
    { text: "Descrição", style: "table_header" },
    { text: "Unid.", style: "table_header" },
    { text: "Quant.", style: "table_header" },
    { text: "Valor Unit. R$", style: "table_header" },
    { text: "Valor Total R$", style: "table_header" }
  ]);

  orcamento.etapas.forEach(etapa => {
    planilha.push([{ text: `${etapa.codigo} ${etapa.nome}`, colSpan: 6, style: "h6" }, {}, {}, {}, {}, {}]);

    etapa.itens.forEach(item => {
      planilha.push([{ text: item.codigo, style: "h6" }, { text: item.nome, colSpan: 5, style: "h6" }, {}, {}, {}, {}]);

      item.servicos.forEach((servico, x) => {
        planilha.push([
          { text: `${item.codigo}.${x + 1}`, bold: true },
          { text: servico.nome, bold: true },
          { text: CsTipoUnidade.valueOf(servico.tipoUnidade).simbolo, bold: true },
          { text: util.quantidade(servico.quantidade), bold: true },
          { text: servico.valorTotal, alignment: "right", bold: true },
          { text: servico.valorTotalGeral, alignment: "right", bold: true }
        ]);

        servico.itens.forEach(i => {
          planilha.push([
            {},
            { text: i.nome },
            { text: CsTipoUnidade.valueOf(i.tipoUnidade).simbolo },
            { text: util.quantidade(i.quantidade) },
            { text: util.moeda(i.valor), alignment: "right" },
            { text: util.moeda(i.valorTotal), alignment: "right" }
          ]);
        });

        planilha.push([
          { text: "TOTAL", colSpan: 4, alignment: "right" },
          {},
          {},
          {},
          { text: util.moeda(item.valorTotal), colSpan: 2, alignment: "right" }
        ]);
      });

      planilha.push([
        {
          text: "TOTAL",
          colSpan: 4,
          alignment: "right",
          bold: true
        },
        {},
        {},
        {},
        {
          text: util.moeda(item.valorTotal),
          colSpan: 2,
          alignment: "right",
          bold: true
        }
      ]);
    });

    planilha.push([
      { text: "VALOR DOS SERVIÇOS NESTA ESTAPA", colSpan: 4, style: "h6" },
      {},
      {},
      {},
      {
        text: util.moeda(etapa.valorTotal),
        colSpan: 2,
        style: "h6",
        alignment: "right"
      }
    ]);
  });

  planilha.push([
    { text: "TOTAL GERAL", style: "h6", colSpan: 5 },
    {},
    {},
    {},
    {},
    { text: util.moeda(orcamento.valorTotalGeral), style: "h6", alignment: "right" }
  ]);

  const doc = {
    content: [
      detalheOrcamento(orcamento, usuario),
      defaultHeader(empresa, orcamento.nome, usuario),
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 1,
            x2: 565,
            y2: 1,
            lineWidth: 0.1,
            lineColor: "#c8ced3"
          }
        ],
        margin: [0, 10, 0, 10]
      },
      { text: "PLANILHA DE PREÇOS", style: ["header", "text_primary"] },
      {
        style: "table",
        table: {
          headerRows: 1,
          widths: [30, "*", 25, 45, 60, 90],
          body: planilha.slice()
        }
      }
    ],
    footer: defaultFooter,
    defaultFileName: "orcamento.pdf",
    pageSize: "A4",
    pageOrientation: "portrait",
    pageMargins: [15, 20, 15, 30],
    styles: defaultStyles
  };

  const { vfs } = vfsFonts.pdfMake;
  pdfMake.vfs = vfs;

  pdfMake.createPdf(doc).open();
};

class RelatorioOrcamentoStore {
  exportar = (empresa, orcamento) => {
    const usuario = sessaoStore.usuario;
    exportarRelatorio(empresa, orcamento, usuario);
  };

  exportarDetalhe = (empresa, orcamento) => {
    const usuario = sessaoStore.usuario;
    exportarDetalhe(empresa, orcamento, usuario);
  };
}

export default new RelatorioOrcamentoStore();



// WEBPACK FOOTER //
// ./src/views/cadastros/orcamentos/stores/Relatorio.js